(function () {
  'use strict';

  angular
    .module('examination')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('examination', {
        url: '/examination',
        templateUrl: 'examination/examination.tpl.html',
        controller: 'ExaminationCtrl',
        controllerAs: 'examination'
      });
  }
}());
